<div [class.hidden]="!visible" [class.fullscreen]="fullscreen" id="consolelogger" (click)="toggleFullscreen()">
    <h3>Console (click to toggle fullscreen)</h3>
    <div id="log"></div>
</div>
